import React, { type SyntheticEvent, useEffect, useState } from "react";
import { shallowEqual } from "react-redux";
import * as Styles from "./styles/MobileFooterStyles";
import { type BuildAndBuyDispatchType, useBnbSelector } from "../../../../redux/store";
import { showMobileBasket } from "../../../../../../../common-deprecated/redux/actions/UtilActions";
import MobileBasket from "../basket/MobileBasket";
import BasketButton from "./BasketButton";
import { BnbLabel } from "../../../../utils/labels";
import { NavOrigin, NavStep } from "../../../../../shared-logic/utils/Navigation";
import FinanceInsuranceCalculatorLink from "../../../../utils/FinanceInsuranceCalculatorLink";
import { FINANCE_CALCULATOR } from "../../../../../../../common-deprecated/constants";
import { showModal } from "../../../../../../../common-deprecated/redux/actions/ModalActions";
import { MODAL_FINANCE_TOGGLE } from "../../../../utils/modalConstants";
import { getMobileReachoutModalSize } from "../../../../../../../common-deprecated/utils";
import { trackBasketMobileOpen, trackFinanceToggle } from "../../../../utils/tracking";
import { IconWrapper } from "../../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import { useFinanceInsuranceNavigation } from "../../../../hooks/shared/useFinanceInsurance";
import { MobileNextButton } from "./MobileNextButton";
import { enabledServicesSelector } from "../../../../utils/selectorUtils";
import Icon from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { LineClamp } from "../../../../../../../common-deprecated/styles/v2/toyota/utilities/LineClamp";
import { useDispatch } from "../../../../../../../shared-logic/redux/store";

const MobileFooter = (): JSX.Element | null => {
    const dispatch = useDispatch<BuildAndBuyDispatchType>();

    const mobileBasketIsShown = useBnbSelector((state) => state.utils.showMobileBasket);
    const step = useBnbSelector((state) => state.navigation.step);
    const financeOption = useBnbSelector((state) => state.utils.financeOption);
    const { showMonthlyRateCarConfig, showFinanceInsuranceInPage, enableFinanceCompare } = useBnbSelector(
        (state) => state.bnbSettings,
    );
    const { showInsurance } = useBnbSelector(enabledServicesSelector, shallowEqual);

    const [mobileReachoutHeight, setMobileReachoutHeight] = useState(0);

    const toggleBasketOpen = (event: SyntheticEvent): void => {
        event.preventDefault();
        if (!mobileBasketIsShown) trackBasketMobileOpen(step);
        dispatch(showMobileBasket(!mobileBasketIsShown));
    };

    const openCashToggleModal = (): void => {
        trackFinanceToggle(step, "cash", "cc-footer");
        dispatch(showModal({ type: MODAL_FINANCE_TOGGLE }));
    };

    useEffect(() => {
        // check if the injected reachout component is available
        if (getMobileReachoutModalSize()) {
            setMobileReachoutHeight(getMobileReachoutModalSize());
        }
    }, []);

    const { onClick, insuranceLabelKey } = useFinanceInsuranceNavigation(step);

    if (step === NavStep.Model || step === NavStep.Engine) return null;

    return (
        <>
            <Styles.Wrapper reachOutMobile={mobileReachoutHeight}>
                <Styles.Body>
                    <BasketButton toggle={toggleBasketOpen} />
                    <MobileNextButton step={step} financeOption={financeOption} />
                </Styles.Body>
                {(showFinanceInsuranceInPage || enableFinanceCompare) && showMonthlyRateCarConfig ? (
                    <Styles.PaymentControls>
                        <Styles.PaymentSwitch
                            type="button"
                            onClick={(event) => onClick(event, "cc-footer", NavOrigin.FinancialCta)}
                        >
                            <IconWrapper>
                                <Icon variant="card" />
                            </IconWrapper>
                            <LineClamp>
                                <BnbLabel
                                    label={financeOption === "monthly" ? "financeCollapsableTitle" : "financeButton"}
                                />
                            </LineClamp>
                        </Styles.PaymentSwitch>
                        {showInsurance && (
                            <Styles.PaymentSwitch
                                type="button"
                                onClick={(event) => onClick(event, "cc-footer", NavOrigin.InsuranceCta)}
                            >
                                <IconWrapper>
                                    <Icon variant="insurance" />
                                </IconWrapper>
                                <LineClamp>
                                    <BnbLabel label={insuranceLabelKey} />
                                </LineClamp>
                            </Styles.PaymentSwitch>
                        )}
                    </Styles.PaymentControls>
                ) : financeOption === "cash" ? (
                    <FinanceInsuranceCalculatorLink
                        type={FINANCE_CALCULATOR}
                        customButton={(props) => (
                            <Styles.PaymentSwitch
                                type="button"
                                onClick={() => {
                                    trackFinanceToggle(step, "monthly", "cc-footer");
                                    props.onClick(true);
                                }}
                            >
                                <BnbLabel label="financeOptionQuestionMonthly" />
                            </Styles.PaymentSwitch>
                        )}
                    />
                ) : (
                    showMonthlyRateCarConfig && (
                        <Styles.PaymentSwitch type="button" onClick={openCashToggleModal}>
                            <BnbLabel label="financeOptionQuestionCash" />
                        </Styles.PaymentSwitch>
                    )
                )}
            </Styles.Wrapper>

            {mobileBasketIsShown && <MobileBasket />}
        </>
    );
};
export default MobileFooter;
